import { Component, OnInit, Input } from '@angular/core';
interface BodaStage {
  bodabodaStageChairmanName: string;
  bodabodaStageChairmanPhone1: string;
  bodabodaStageId: number;
  bodabodaStageName: string;
  count: number;
  createdBy: string;
  stageClusterName: string;
}
@Component({
  selector: 'app-boda-stages',
  templateUrl: './boda-stages.component.html',
  styleUrls: ['./boda-stages.component.scss']
})
export class BodaStagesComponent implements OnInit {

  constructor() { }
  @Input() itm: BodaStage;
  ngOnInit(): void {
  }

}
